// extracted by mini-css-extract-plugin
export default {"container":"Steps_container__E8-EV","left":"Steps_left__w-7TC","image":"Steps_image__pZKGu","right":"Steps_right__ZSqWl","button":"Steps_button__6no40"};